import type { Language } from "@app/constants";
import type { AccountType } from "@app/entities";

interface Messages {
	amount: string;
	header: string;
	placeholder: string;
	submit: string;
	tooltip: {
		amount: string;
	};
	errors: {
		fieldsRequired: string;
		generic: string;
	};
	bankName: string;
	branchCode: string;
	accountNumber: string;
	accountType: {
		[key in AccountType]: string;
	} & { header: string };
	withdrawalFee: string;
	withdrawalFeeTitle: string;
	withdrawalTypePlaceholder: string;
	withdrawalType: string;
	withdrawAll: string;
	withdrawAllDropdownItems: {
		yes: string;
		no: string;
	};
	withdrawalTypeDropdownItems: {
		standard: string;
		fast: string;
	};
	footnotes: {
		withdrawalType: string;
		withdrawalFee: string;
	};
}

type Message = {
	[key in Language]: Messages;
};

const messages: Message = {
	en: {
		amount: "Amount",
		header: "Confirm withdrawal",
		placeholder: "0.00",
		submit: "SUBMIT",
		tooltip: {
			amount: "Please enter the amount you wish to withdraw",
		},
		errors: {
			fieldsRequired: "Please complete the required fields highlighted in red",
			generic: "There are errors in your submission. Please see above.",
		},
		bankName: "Bank: ",
		branchCode: "Branch Code: ",
		accountType: {
			header: "Account Type: ",
			bond: "Bond Account",
			cheque: "Current/Cheque Account",
			credit: "Credit Card Account",
			savings: "Savings Account",
			subscription: "Subscription Account",
			transmission: "Transmission Account",
		},
		accountNumber: "Account Number: ",
		withdrawAll: "Withdraw all",
		withdrawalFee: "ZAR 20.00",
		withdrawalFeeTitle: "Capitec Withdrawal Fee",
		withdrawalTypePlaceholder: "Select a withdrawal type",
		withdrawalType: "Withdrawal Type",
		withdrawAllDropdownItems: {
			yes: "Yes",
			no: "No",
		},
		withdrawalTypeDropdownItems: {
			standard: "Standard (Fee: R20.00)",
			fast: "STP/Fast (Fee: R60.00)",
		},
		footnotes: {
			withdrawalType:
				"A Standard withdrawal will typically take 3 business days to reflect in your account, whereas a STP/Fast withdrawal typically takes 1-2 business days.",
			withdrawalFee:
				"This processing fee is charged by Capitec. We do not charge any fees/commission on top of this.",
		},
	},
};

export default messages;
